import _ from 'lodash'

export const dynamicWFSchema = (spec) => Object.assign({}, spec, { 'id': _.uniqueId('WFO_'),
                                                                   'type': 'dynamic-workflow',
                                                                   'loading': true})



// WEBPACK FOOTER //
// ./src/schema/dynamic-workflows.js